module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "layout",
    attrs: {
      "id": "main"
    }
  }, [_h('div', {
    staticClass: "upper-box",
    style: (upperStyleObj)
  }, [_h('div', {
    staticClass: "center-box"
  }, [_h('div', {
    staticClass: "center-box-inner",
    style: (centerStyleObj)
  }, [_h('parse-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseTree.open),
      expression: "parseTree.open"
    }],
    class: {
      'active-box': currentActiveBox == 'parseTree'
    },
    attrs: {
      "width": parseTreeWidth
    },
    on: {
      "parse-tree:resize": onParseTreeResize,
      "parse-tree:close": onParseTreeClose,
      "click": function($event) {
        currentActiveBox = 'parseTree'
      }
    }
  }), " ", _h('editor', {
    style: ({
      width: editorWidth + 'px'
    }),
    on: {
      "click": function($event) {
        currentActiveBox = 'editor'
      }
    }
  })])]), " ", _h('workspace', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (workspace.open),
      expression: "workspace.open"
    }],
    class: {
      'active-box': currentActiveBox == 'workspace'
    },
    style: (leftStyleObj),
    attrs: {
      "width": workspaceWidth
    },
    on: {
      "workspace:resize": onWorkspaceResize,
      "workspace:close": onWorkspaceClose,
      "click": function($event) {
        currentActiveBox = 'workspace'
      }
    }
  }), " ", _h('symbol-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (symbolTable.open),
      expression: "symbolTable.open"
    }],
    class: {
      'active-box': currentActiveBox == 'symbolTable'
    },
    style: (rightStyleObj),
    attrs: {
      "width": symbolTableWidth
    },
    on: {
      "symbol-table:resize": onSymbolTableResize,
      "symbol-table:close": onSymbolTableClose,
      "click": function($event) {
        currentActiveBox = 'symbolTable'
      }
    }
  })]), " ", _h('console', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (console.open),
      expression: "console.open"
    }],
    class: {
      'active-box': currentActiveBox == 'console'
    },
    attrs: {
      "height": consoleHeight
    },
    on: {
      "console:close": onConsoleClose,
      "console:resize": onConsoleResize,
      "click": function($event) {
        currentActiveBox = 'console'
      }
    }
  })])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-b0b080c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
 ** module id = 133
 ** module chunks = 2
 **/